import { render } from "./SFAContracts.vue?vue&type=template&id=078b5916"
import script from "./SFAContracts.vue?vue&type=script&lang=js"
export * from "./SFAContracts.vue?vue&type=script&lang=js"

import exportComponent from "/home/desarollo2/Documents/GitHub/dicora-customers-app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__